import { Card } from '@drone-js/core';
import styled from 'styled-components';

// Temporary Fix for padding issues
const WalletCard = styled(Card)`
    * {
        box-sizing: border-box;
    }

    @media (min-width: 768px) {
        max-width: 55vw;
    }

    @media (min-width: 1200px) {
        max-width: 35vw;
    }
`;

export default WalletCard;
